import React from 'react';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import styled from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3;
var LabelContainer = styled.label(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var LabelText = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  font-size: 14px;\n  line-height: 24px;\n  font-weight: ", ";\n  margin-bottom: 4px;\n  color: ", ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
}, function (p) {
  return p.theme.fontWeights.semiBold;
}, function (p) {
  return p.disabled && p.theme.palette.gray['200'] || (p.hasError && p.labelErrorIsRed ? p.theme.palette.red['700'] : p.theme.palette.black) || p.theme.palette.black;
});
var SymbolCount = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 16px;\n  font-weight: ", ";\n"])), function (p) {
  return p.theme.fontWeights.regular;
});

function Label(_ref) {
  var children = _ref.children,
      hasError = _ref.hasError,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      disabled = _ref.disabled,
      label = _ref.label,
      _ref$labelCanDisabled = _ref.labelCanDisabled,
      labelCanDisabled = _ref$labelCanDisabled === void 0 ? false : _ref$labelCanDisabled,
      labelCount = _ref.labelCount,
      labelMaxCount = _ref.labelMaxCount;
  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(LabelContainer, {
    className: className
  }, !label ? children : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LabelText, {
    hasError: hasError,
    disabled: labelCanDisabled ? disabled : false
  }, /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement(SymbolCount, null, labelCount === undefined && labelMaxCount !== undefined ? '–' : labelCount, labelMaxCount !== undefined && ' / ', labelMaxCount)), children)));
}

export { Label };
